import httpClient from './httpClient'

const END_POINT = '/api/forma_conocers'

const getAllFormas = () => httpClient.get(END_POINT)

export {

    getAllFormas

}